import { useState } from 'react';
import PropTypes from 'prop-types';
import { Box, MenuItem } from '@mui/material';
import DropdownAction from './DropdownAction';
import Iconify from '../iconify';

DropdownExpandableAction.propTypes = {
  icon: PropTypes.string,
  children: PropTypes.node,
  panel: PropTypes.node,
  defaultExpanded: PropTypes.bool,
  onExpandedChange: PropTypes.func,
  disabled: PropTypes.bool,
  iconColor: PropTypes.string,
  iconBgColor: PropTypes.string,
  textColor: PropTypes.string,
};

export default function DropdownExpandableAction({
  icon,
  children,
  panel,
  defaultExpanded = false,
  onExpandedChange,
  disabled = false,
  iconColor,
  iconBgColor,
  textColor,
}) {
  const [expanded, setExpanded] = useState(defaultExpanded);

  const toggle = () => {
    setExpanded((prev) => {
      const next = !prev;
      onExpandedChange?.(next);
      return next;
    });
  };

  return (
    <>
      <MenuItem
        disableRipple
        disableGutters
        sx={{
          p: 0,
          minHeight: 'unset',
          '&:hover': {
            bgcolor: 'transparent',
          },
        }}
        disabled={disabled}
        onClick={toggle}
      >
        <DropdownAction
          badgeIcon={icon}
          iconColor={iconColor}
          iconBgColor={iconBgColor}
          textColor={textColor}
          endIcon={<Iconify icon={expanded ? 'mdi:chevron-up' : 'mdi:chevron-down'} width={18} />}
        >
          {children}
        </DropdownAction>
      </MenuItem>

      {expanded && <Box sx={{ px: 2, py: 1 }}>{panel}</Box>}
    </>
  );
}